import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Paper, Box, ButtonGroup, IconButton, Tooltip, ListItem, List } from '@mui/material';
import {
    FormatBold as FormatBoldIcon, FormatItalicOutlined as FormatItalicOutlinedIcon,
    FormatUnderlinedOutlined as FormatUnderlinedOutlinedIcon,
    FormatAlignLeftOutlined as FormatAlignLeftOutlinedIcon,
    FormatAlignCenterOutlined as FormatAlignCenterOutlinedIcon,
    FormatAlignRightOutlined as FormatAlignRightOutlinedIcon
} from '@mui/icons-material';
import { SuggestionPopup } from "./SarasCommonComp";
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import VoiceToText from '../../../../Components/Common Components/VoiceToText';
import { debounce } from '../../../../Components/CommonFunctions/CommonFunctions';
import MicIcon from '@mui/icons-material/Mic';
import { grey } from '@mui/material/colors';

const buttonConfig = [
    { label: 'Bold', icon: <FormatBoldIcon />, style: 'bold' },
    { label: 'Italic', icon: <FormatItalicOutlinedIcon />, style: 'italic' },
    { label: 'Underline', icon: <FormatUnderlinedOutlinedIcon />, style: 'underline' },
    { label: 'Left Align', icon: <FormatAlignLeftOutlinedIcon />, style: 'justifyLeft' },
    { label: 'Center Align', icon: <FormatAlignCenterOutlinedIcon />, style: 'justifyCenter' },
    { label: 'Right Align', icon: <FormatAlignRightOutlinedIcon />, style: 'justifyRight' },
];

const SarasToolsFieldWithMic = ({ EditorRef, Title = '', overallHeight, EditorDisable, maxChar = 600, EditorHeight, minHeight, ...props }) => {
    const editorRef = useRef(null);
    const paperRef = useRef(null);
    const savedRangeRef = useRef(null);
    const initialized = useRef(false);
    const skipSaveRef = useRef(false);

    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [state, setState] = useState({
        bold: false,
        italic: false,
        underline: false,
        justifyLeft: false,
        justifyCenter: false,
        justifyRight: false,
        bulletList: false,
        orderedList: false,
        disableEdit: true,
        editedContent: '',
        isOutFocus: false,
        listenPopUp: false,
        ClickKey: false,

        // suggestion state
        suggestionsMap: {},
        showSuggestions: false,
        suggestionPos: { top: 0, left: 0 },
        isSuggestionOpen: false,
    });

    // const debouncedSendSavedData = useRef(debounce(() => {
    //     sendSavedData();
    // }, 300));

    useEffect(() => {
        getSuggestionList();
    }, []);

    useEffect(() => {
        if (state.listenPopUp === false) {
            editorRef.current?.focus();
        }
    }, [state.listenPopUp]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                editorRef.current &&
                !editorRef.current.contains(event.target) &&
                paperRef.current &&
                !paperRef.current.contains(event.target)
            ) {
                updateState({ showSuggestions: false });
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    useEffect(() => {
        // template data set 
        if (editorRef.current) {
            const editor = editorRef.current;

            const currentLength = getTextLength(editor.innerHTML);
            const templateText = getTextLength(EditorRef || "");

            if (props.isFromTemplate && ((currentLength + templateText) > maxChar)) {
                props.errorMessage(`You have reached the ${maxChar}-character limit`);
                return;
            } else {
                editor.innerHTML = EditorRef || "";
            }         
        }
    }, [EditorRef]);

    useEffect(() => {
        if(props.isSaveClicked){
            sendSavedData();
        }
    }, [props.isSaveClicked])
    
    useEffect(() => {
        if(props.isClearClicked){
            editorRef.current.innerHTML = "";
        }
    }, [props.isClearClicked])

    // Open suggestion edit popup on Ctrl + Shift + S
    // useEffect(() => {
    //     const handleKeyDown = (e) => {
    //         try {
    //             if (props?.isSelected && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 's') {
    //                 e.preventDefault();

    //                 setState((prev) => {
    //                     console.log('Updater prev:', prev);
    //                     return {
    //                         ...(typeof prev === 'object' && prev !== null ? prev : {}),
    //                         isSuggestionOpen: true,
    //                     };
    //                 });
    //             } else if (props?.isSelected && e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'h') {
    //                 e.preventDefault(); // Optional: prevent any default browser behavior
    //                 postSuggest();      // Call your save API
    //             }
    //         } catch (err) {
    //             console.error('KeyDown failed:', err);
    //         }
    //     };

    //     window.addEventListener('keydown', handleKeyDown);
    //     return () => window.removeEventListener('keydown', handleKeyDown);
    // }, [props?.isSelected]);

    // api call of Suggest Data start
    const getSuggestionList = useCallback(() => {
        if (!props.url) return;
        let apiUrl = props?.fromIp && props.isNewLayout ?
            `${Serviceurls[props.url]}?system_name=${props.systemName}&clinic_id=${props?.clinicId}&doctor_id=${props?.doctor_id}&ip_admission_id=${props?.admission_id}` :
            props?.fromIp ? `${Serviceurls[props.url]}?clinic_id=${props?.clinicId}&doctor_id=${props?.doctor_id}&ip_admission_id=${props?.admission_id}` :
                props.isNewLayout ? `${Serviceurls[props.url]}?system_name=${props.systemName}` : `${Serviceurls[props.url]}`
        try {
            RestAPIService.getAllTwo(apiUrl)
                .then((response) => {
                    if (response.data.status === "success") {
                        if (props.systemName === "Allergies") {
                            setState((prev) => ({
                                ...prev,
                                suggestionsMap: {
                                    ...prev.suggestionsMap,
                                    ["medication_allergy"]: response.data?.medication_allergy,
                                    ["non_medication_allergy"]: response.data?.non_medication_allergy,
                                }
                            }))
                        } else {
                            const data = response.data.data || [];
                            setState((prev) => ({
                                ...prev,
                                suggestionsMap: {
                                    ...prev.suggestionsMap,
                                    [props.field_name]: data
                                }
                            }))
                        }
                    }
                    else {
                        props.errorMessage(response.data.message)
                    }
                }).catch((error) => {
                    props.errorMessage(error.message)
                })
        }
        catch (e) {
            props.errorMessage(e.message)
        }
    }, [props.url, props.systemName, props.isNewLayout, props.field_name])

    useEffect(() => {
        if (!initialized.current && props.callSuggestGet) {
            props.callSuggestGet(getSuggestionList);
            initialized.current = true;
        }
    }, [props.callSuggestGet, getSuggestionList]);
    // api call of Suggest Data end

    const updateState = (updates) => {        
        setState((prev) => ({ ...prev, ...updates }));
    };

    // Save the selection range
    const saveSelection = () => {
        const sel = window.getSelection();
        if (sel && sel.rangeCount > 0) {
            return sel.getRangeAt(0).cloneRange();
        }
        return null;
    };

    // Restore a previously saved range
    const restoreSelection = (range) => {
        if (!range) return;
        const sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    };

    const handleStyleChange = useCallback((command) => {        
        const editor = editorRef.current;
        if (!editor) return;
        const savedRange = saveSelection(); // Save current selection
        // skipSaveRef.current = true;
        restoreSelection(savedRange); // Restore before applying style        

        document.execCommand(command, false, null);
        editor?.focus();
        const toggleState = (key) => updateState({ [key]: !state[key] });

        switch (command) {
            case 'bold': toggleState('bold'); break;
            case 'italic': toggleState('italic'); break;
            case 'underline': toggleState('underline'); break;
            case 'insertUnorderedList': toggleState('bulletList'); break;
            case 'insertOrderedList': toggleState('orderedList'); break;
            case 'justifyLeft':
            case 'justifyCenter':
            case 'justifyRight':
                updateState({
                    justifyLeft: command === 'justifyLeft',
                    justifyCenter: command === 'justifyCenter',
                    justifyRight: command === 'justifyRight',
                });
                break;
            default:
                setTimeout(() => {
                    if (!state.justifyCenter && !state.justifyRight) {
                        updateState({ justifyLeft: true });
                        document.execCommand('justifyLeft', false, null);
                    }
                }, 0);
                break;
        }
        // setTimeout(() => {
        //     // reset the flag after a short delay
        //     skipSaveRef.current = false;
        // }, 350); commented to avoid skipping save
    }, [state]);

    const handlePaste = (event) => {
        event.preventDefault();
        const clipboardData = event.clipboardData || window.clipboardData;

        const htmlData = clipboardData.getData("text/html");
        const plainText = clipboardData.getData("text/plain");

        if (htmlData) {
            document.execCommand("insertHTML", false, stripHtml(htmlData));
        } else {
            document.execCommand("insertText", false, plainText);
        }
    };

    const clearStyleState = () => {
        updateState({
            disableEdit: true,
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            bulletList: false,
            orderedList: false,
        });
    };

    const getTextStylesAtCursor = () => {
        updateState({
            italic: false,
            bold: false,
            underline: false,
            justifyLeft: false,
            justifyCenter: false,
            justifyRight: false,
            disableEdit: false,
        });

        const selection = window.getSelection();
        if (!selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        const node = range.commonAncestorContainer;
        const textNode = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
        const computedStyle = window.getComputedStyle(textNode);
        const textStyle = {
            fontWeight: computedStyle.fontWeight,
            fontStyle: computedStyle.fontStyle,
            textDecoration: computedStyle.textDecoration,
            textAlign: computedStyle.textAlign
        };

        if (textStyle.fontStyle === "italic" || document.queryCommandState('italic')) updateState({ italic: true });
        if (textStyle.fontWeight === '700' || document.queryCommandState('bold')) updateState({ bold: true });
        if (textStyle.textDecoration.includes("underline") || document.queryCommandState('underline')) updateState({ underline: true });

        if (textStyle.textAlign === 'left') updateState({ justifyLeft: true });
        if (textStyle.textAlign === 'center') updateState({ justifyCenter: true });
        if (textStyle.textAlign === 'right') updateState({ justifyRight: true });
    };

    const handleMicClick = () => {
        updateState({ ClickKey: true, listenPopUp: true, isOutFocus: true });
    };

    const voiceToTextgetter = (textStorage) => {
        if (!textStorage || !state.ClickKey) return;
        const editor = editorRef.current;
        if (!editor) return;

        const currentLength = getTextLength(editor.innerHTML);
        const micTextLength = getTextLength(textStorage);

        if (currentLength + micTextLength > maxChar) {
            props.errorMessage(`You have reached the ${maxChar}-character limit`);
            return;
        }
        setTimeout(() => {
            if (editorRef.current) {
                editorRef.current.innerHTML += textStorage;
                editorRef.current.setAttribute("contentEditable", "true");
                editorRef.current.focus();

                const range = document.createRange();
                const sel = window.getSelection();
                range.selectNodeContents(editorRef.current);
                range.collapse(false);
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }, 0);
        // debouncedSendSavedData.current();
    };

    const removeEmptyStyleTagsAndReplaceSpan = (content) => {
        const div = document.createElement('div');
        div.innerHTML = content;

        const elements = div.querySelectorAll('*[style]');
        elements.forEach((el) => {
            const retained = el.getAttribute('style')
                .split(';')
                .map((r) => r.trim())
                .filter((r) => r.startsWith('text-align'))
                .join('; ');
            retained ? el.setAttribute('style', retained) : el.removeAttribute('style');
        });

        div.querySelectorAll('span').forEach((span) => {
            const newDiv = document.createElement('div');
            Array.from(span.attributes).forEach(attr => newDiv.setAttribute(attr.name, attr.value));
            while (span.firstChild) newDiv.appendChild(span.firstChild);
            span.parentNode.replaceChild(newDiv, span);
        });

        const firstDiv = div.firstElementChild;
        if (firstDiv?.tagName.toLowerCase() === 'div') {
            const style = firstDiv.getAttribute('style');
            if (style && style.includes('text-align')) {
                const match = style.match(/text-align:\s*(left|right|center)/);
                firstDiv.setAttribute('style', match ? match[0] : 'text-align: left;');
            } else {
                firstDiv.setAttribute('style', 'text-align: left;');
            }
        }

        div.querySelectorAll('b, i, u').forEach((inlineEl) => {
            inlineEl.querySelectorAll('div').forEach((blockEl) => {
                const frag = document.createDocumentFragment();
                if (blockEl.hasAttribute('style')) {
                    inlineEl.setAttribute('style', blockEl.getAttribute('style'));
                }
                while (blockEl.firstChild) frag.appendChild(blockEl.firstChild);
                blockEl.replaceWith(frag);
            });
        });

        return div.innerHTML === "<br>" ? "" : div.innerHTML;
    };

    const sendSavedData = () => {
        if (state.isOutFocus) {
            clearStyleState();
        }

        const cleanedContent = removeEmptyStyleTagsAndReplaceSpan(editorRef?.current?.innerHTML);
        props.saveData(props?.stateName, cleanedContent);
    };

    const getTextLength = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent.length;
    };

    function trimHtmlContentToMaxLength(html, maxLength) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        let currentLength = 0;

        const trimNode = (node) => {
            if (currentLength >= maxLength) return null;

            if (node.nodeType === Node.TEXT_NODE) {
                const remaining = maxLength - currentLength;
                const text = node.textContent.slice(0, remaining);
                currentLength += text.length;
                return document.createTextNode(text);
            }

            if (node.nodeType === Node.ELEMENT_NODE) {
                const clone = node.cloneNode(false);
                for (const child of node.childNodes) {
                    const trimmedChild = trimNode(child);
                    if (trimmedChild) clone.appendChild(trimmedChild);
                    if (currentLength >= maxLength) break;
                }
                return clone;
            }

            return null;
        };

        const resultDiv = document.createElement('div');
        for (const child of tempDiv.childNodes) {
            const trimmedChild = trimNode(child);
            if (trimmedChild) resultDiv.appendChild(trimmedChild);
            if (currentLength >= maxLength) break;
        }

        return resultDiv.innerHTML;
    }

    const getCurrentWord = () => {
        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return '';

        const range = sel.getRangeAt(0);
        const precedingRange = range.cloneRange();

        precedingRange.selectNodeContents(editorRef.current);
        precedingRange.setEnd(range.endContainer, range.endOffset);

        const text = precedingRange.toString();
        const words = text.split(/\s+/);
        return words?.length > 0 ? words[words.length - 1] : "";
    };

    const stripHtml = (html) => html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

    const handleEditorInput = useCallback(() => {
        const editor = editorRef.current;
        if (!editor) return;

        const plainTextLength = getTextLength(editor.innerHTML);

        if (plainTextLength > maxChar) {
            props.errorMessage(`You have reached the ${maxChar}-character limit`);
            const trimmedText = trimHtmlContentToMaxLength(editor.innerHTML, maxChar);
            editor.innerHTML = trimmedText;

            // Re-save caret after trimming
            setTimeout(() => {
                const sel = window.getSelection();
                if (sel && sel.rangeCount > 0) {
                    savedRangeRef.current = sel.getRangeAt(0).cloneRange();
                }
            }, 500);
            return;
        }

        const word = getCurrentWord();
        const fieldKey = (props.systemName === "Allergies" && props?.stateName === "comments2")
            ? props.postKey2
            : (props.systemName === "Allergies" && props?.stateName === "comments")
                ? props.postKey
                : props?.field_name;

        const itemKey = props.stateName === "comments2"
            ? props.postKey2
            : props.postKey || props.stateName;

        if (word.length >= 3 && state?.suggestionsMap[fieldKey]) {
            const rect = editor.getBoundingClientRect();
            const editorWidth = rect.width;

            const exitSuggest = filteredSuggestions.length > 0
                ? filteredSuggestions
                : state.suggestionsMap[fieldKey];

            const matches = exitSuggest.filter(item => {
                const suggestionText = stripHtml(item?.[itemKey] || '').toLowerCase();
                return suggestionText.includes(word.toLowerCase());
            });

            setFilteredSuggestions(matches);

            updateState({
                showSuggestions: true,
                suggestionPos: {
                    top: rect.bottom + window.scrollY,
                    left: rect.left + window.scrollX,
                },
                suggestionBoxWidth: editorWidth,
            });
        } else {
            updateState({ showSuggestions: false });
            setFilteredSuggestions([]);
        }

        // Save caret after update
        setTimeout(() => {
            const sel = window.getSelection();
            if (sel && sel.rangeCount > 0) {
                savedRangeRef.current = sel.getRangeAt(0).cloneRange();
            }
        }, 500);

        // if (!skipSaveRef.current) {
        //     debouncedSendSavedData.current();
        // }
    }, [state?.suggestionsMap, filteredSuggestions]);

    const handleBeforeInput = (e) => {
        const editor = editorRef.current;
        if (!editor) return;

        const textContent = editor.textContent || '';
        const selection = window.getSelection();
        const inputText = e.data || ''; // text being input

        const newLength = textContent.length + inputText.length - (selection?.toString().length || 0);

        if (newLength > maxChar) {
            e.preventDefault();
            props.errorMessage(`You have reached the ${maxChar}-character limit`);
        }
    };

    const escapeHtml = (unsafe) => {
    return unsafe
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    };

    const getHighlightedSuggestion = (text, typedText) => {
        if (!text || !typedText) return text;

        const cleanSuggestion = stripHtml(text); // Strip all HTML
        const escapedSuggestion = escapeHtml(cleanSuggestion); // Escape to prevent breaking HTML

        const typedWords = typedText.trim().split(/\s+/).filter(w => w.length >= 3);
        if (typedWords.length === 0) return escapedSuggestion;

        // Only highlight if word is at beginning of a suggestion word
        const regex = new RegExp(`\\b(${typedWords.join('|')})`, 'ig');

        // Apply highlighting (avoids wrapping substrings inside other words)
        const highlighted = escapedSuggestion.replace(regex, (match) => {
            return `<b style="color:black;">${match}</b>`;
        });

        return highlighted;
    };

    const handleKeyDown = (e) => {
        const editor = editorRef.current;
        if (!editor) return;

        const plainTextLength = getTextLength(editor.innerHTML);

        if (plainTextLength >= maxChar) {
            // Allow only navigation and deletion
            const allowedKeys = [
                'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                'Backspace', 'Delete'
            ];

            if (!allowedKeys.includes(e.key)) {
                e.preventDefault();
                props.errorMessage(`You have reached the ${maxChar}-character limit`);
                return;
            }
        } else if (e.key === "Enter") {  // Custom behavior for Enter key when under limit
            document.execCommand('insertHTML', false, '&nbsp;');
        }
    };
    // render content

    return (
        <Box
            sx={{
                backgroundColor: "#f9f9f9",
                height: overallHeight,
                background: "#FFFF",
                margin: "0.5vw",
                border: '1px solid lightgray',
                borderRadius: "0.25vw",
                padding: "5px",
            }}>
            <Box width={"100%"}>
                {!EditorDisable && <Box
                    className='discharge_Sum_header_container'
                    borderBottom={'1px solid lightgray'}
                    height={'3vw'}
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    justifyContent={'flex-start'}
                    onMouseLeave={() => updateState({ isOutFocus: true })}
                    onMouseOver={() => updateState({ isOutFocus: false })}
                >
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", cursor: "pointer" }}
                        onMouseLeave={() => updateState({ isOutFocus: true })}
                        onMouseOver={() => updateState({ isOutFocus: false })}
                    >
                        <ButtonGroup variant="text" aria-label="text formatting button group">
                            {buttonConfig.map(({ label, icon, style }) => (
                                <Tooltip key={style} title={label} placement="top" arrow>
                                    <IconButton onClick={() => handleStyleChange(style)} size='small'>
                                        {React.cloneElement(icon, { color: state[style] ? 'primary' : 'inherit' })}
                                    </IconButton>
                                </Tooltip>
                            ))}
                        </ButtonGroup>
                    </div>
                    <Tooltip title={"Mic"} placement={"top"} arrow>
                        <IconButton onClick={handleMicClick}>
                            <MicIcon sx={{ color: grey[1000], cursor: "pointer" }} />
                        </IconButton>
                    </Tooltip>
                </Box>}
                <div
                    ref={editorRef}
                    contentEditable={!EditorDisable}
                    onFocus={() => {
                        props.onFocusChange(props.stateName);
                    }}
                    onMouseUp={getTextStylesAtCursor}
                    onSelect={getTextStylesAtCursor}
                    onPaste={handlePaste}
                    onInput={handleEditorInput}
                    onBeforeInput={handleBeforeInput}
                    onKeyDown={handleKeyDown}
                    className='editor'
                    spellCheck="false"
                    style={{ height: EditorHeight, overflow: "auto", minHeight: minHeight || 'auto', outline: "none", whiteSpace:"pre-wrap" }}
                />
                {(state.showSuggestions && filteredSuggestions.length > 0) && (
                    <Paper ref={paperRef}
                        sx={{
                            position: 'absolute',
                            zIndex: 9999,
                            width: state.suggestionBoxWidth,
                            maxHeight: '150px',
                            top: state.suggestionPos.top,
                            left: state.suggestionPos.left,
                            overflowY: 'auto',
                        }}
                    >
                        <List>
                            {filteredSuggestions?.map((item, i) => (
                                <ListItem
                                    key={i}
                                    onClick={() => {
                                        // const editor = editorRef.current;
                                        // if (!editor) return;

                                        // const suggestionText = props.stateName === "comments2"
                                        //     ? item[props.postKey2]
                                        //     : item[props.postKey || props.stateName];

                                        // const content = editor.textContent.trim();
                                        // const words = content.split(/\s+/);
                                        // const suggestionLower = suggestionText.toLowerCase();
                                        // let replaced = false;
                                        // // const content = editor.innerText;
                                        // // const words = content.trim().split(/\s+/);

                                        // for (let i = words.length; i >= 1; i--) {
                                        //     const slice = words.slice(-i).join(' ').toLowerCase();
                                        //     if (suggestionLower.includes(slice)) {
                                        //         const newWords = [...words.slice(0, -i), suggestionText];
                                        //         editor.innerHTML = newWords.join(' ');
                                        //         replaced = true;
                                        //         break;
                                        //     }
                                        // }

                                        // // If no match at all, just append
                                        // if (!replaced) {
                                        //     editor.innerHTML = content + ' ' + suggestionText;
                                        // }
                                        // // Replace last word with selected suggestion
                                        // // words[words.length - 1] = suggestionText;
                                        // // editor.innerHTML = words.join(" ");

                                        // // Move caret to end
                                        // const range = document.createRange();
                                        // const sel = window.getSelection();
                                        // range.selectNodeContents(editor);
                                        // range.collapse(false);
                                        // sel.removeAllRanges();
                                        // sel.addRange(range);

                                        // updateState({ showSuggestions: false });
                                        // setFilteredSuggestions([]);
                                        const editor = editorRef.current;
                                        if (!editor || !savedRangeRef.current) return;

                                        const suggestionText =
                                            props.stateName === "comments2"
                                                ? item[props.postKey2]
                                                : item[props.postKey || props.stateName];

                                        const sel = window.getSelection();
                                        sel.removeAllRanges();
                                        sel.addRange(savedRangeRef.current);

                                        const range = sel.getRangeAt(0);
                                        let node = range.endContainer;
                                        let offset = range.endOffset;

                                        if (node.nodeType !== Node.TEXT_NODE) {
                                            const textNode = document.createTextNode('');
                                            range.insertNode(textNode);
                                            node = textNode;
                                            offset = 0;
                                        }

                                        const text = node.textContent;
                                        const beforeCaret = text.slice(0, offset);
                                        const afterCaret = text.slice(offset);

                                        const lines = beforeCaret.split('\n');
                                        const currentLine = lines[lines.length - 1];

                                        const words = currentLine.trim().split(/\s+/);
                                        let matchFound = false;
                                        let matchStart = beforeCaret.length - currentLine.length;

                                        for (let start = 0; start < words.length; start++) {
                                            const candidate = words.slice(start).join(' ');
                                            const candidateIndex = currentLine.lastIndexOf(candidate);

                                            if (
                                                candidateIndex !== -1 &&
                                                suggestionText.toLowerCase().includes(candidate.toLowerCase())
                                            ) {
                                                matchFound = true;
                                                matchStart = beforeCaret.length - currentLine.length + candidateIndex;
                                                break; // Exit after longest match found (because we're iterating from start → end)
                                            }
                                        }


                                        if (matchFound) {
                                            const updatedText =
                                                beforeCaret.slice(0, matchStart) + suggestionText + ' ' + afterCaret;
                                            node.textContent = updatedText;

                                            const newOffset = matchStart + suggestionText.length + 1;
                                            const newRange = document.createRange();
                                            newRange.setStart(node, newOffset);
                                            newRange.setEnd(node, newOffset);
                                            sel.removeAllRanges();
                                            sel.addRange(newRange);
                                        } else {
                                            const insertNode = document.createTextNode(suggestionText + ' ');
                                            range.insertNode(insertNode);
                                            range.setStartAfter(insertNode);
                                            range.collapse(true);
                                            sel.removeAllRanges();
                                            sel.addRange(range);
                                        }

                                        updateState({ showSuggestions: false });
                                        setFilteredSuggestions([]);

                                    }}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: getHighlightedSuggestion(
                                                props.stateName === "comments2"
                                                    ? item[props.postKey2]
                                                    : item[props.postKey || props.stateName],
                                                editorRef.current?.textContent || ''
                                            )
                                        }}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    </Paper>
                )}
            </Box>
            {state.listenPopUp &&
                <VoiceToText
                    voiceTextConverter={voiceToTextgetter.bind(this)}
                    listenPopUp={() => { updateState({ listenPopUp: false }) }}
                    micTextEditDisabled={props.micTextEditDisabled}
                />}
            {
                state.isSuggestionOpen &&
                <SuggestionPopup
                    open={state.isSuggestionOpen}
                    onClose={() => updateState({ isSuggestionOpen: false })}
                    Title={Title}
                    url={props.url || ""}
                    successMessage={(msg) => props.successMessage(msg)}
                    errorMessage={(msg) => props.errorMessage(msg)}
                    postKey={props.postKey || ""}
                    postKey2={props.postKey2 || ""}
                    systemName={props.systemName}
                    field_name={props.field_name}
                    isNewLayout={props.isNewLayout}
                    stateName={props.stateName}
                />
            }
        </Box>
    );
};

export default SarasToolsFieldWithMic;